define('date-formatter',['jquery'],
function ($) {
    var moment = require('moment');
    var body = document.querySelector('body');

    /*
        * Month converter  --------------------------------------
        */

    Date.prototype.getMonthName = function (index) {

        if (document.documentElement.lang != "en") {
            var monthNames = ["Jan", "Feb", "Mar", "Apr", "Maj", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dec"];
        }
        else {
            var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        }
        return monthNames[index];
    }

    /*
        * Event date converter  --------------------------------------
        */

    var eventDateList = document.querySelectorAll('.arrangement-article__info-date .date');
    $(eventDateList).each(function (index) {

        var dateString = $(this)[0].getAttribute('data-date').replace('.', '');
        var date = moment(dateString),
            day = date.date(),
            month = new Date().getMonthName(date.month()),
            year = date.year();

        //var date = new Date(dateString),
        //    day = date.getDate(),
        //    month = new Date().getMonthName(date.getMonth()),
        //    year = date.getFullYear();

        if (day < 10) {
            day = 0 + "" + day
        }

        $(this).find('.day')[0].innerHTML = day;
        $(this).find('.month')[0].innerHTML = month + '<br />' + year;
    });


    /*
    * Event date converter  --------------------------------------
    */

    var newsDateList = document.querySelectorAll('.article-text .date, .news-container .date, .news-list-container .date, .event-container .date, .event-list--date-format .date, .arrangement-hero .date' );
    $(newsDateList).each(function (index, value) { 
        var dateString = $(this)[0].getAttribute('data-date');
        var date = moment(dateString),
            day = date.date(),
            month = new Date().getMonthName(date.month()),
            year = date.year();

        if (day < 10) {
            day = 0 + "" + day
        }

        $(this).find('.day')[0].innerHTML = day;
        $(this).find('.month')[0].innerHTML = '<span>' + month + '</span>' + '<br />' + year;
    });


    /*
    * Event address formatter. Replace trailing ,.  --------------------------------------
    */
    var eventAddress = document.querySelectorAll('.event-container__info-address p, .event-list .location span');

    if (eventAddress) {
        $(eventAddress).each(function () {
            $(this)[0].innerHTML = $(this)[0].innerHTML.replace(/,./g, "<br>");
        })
    }

});



